import { createSnapManager } from './createSnapManager';
import { getSnapSettings } from '../ruler/utils';

let snapManager = null;

/**
 * Initialize the snapping system independently
 * @param {fabric.Canvas} canvas - The fabric canvas
 * @param {Object} options - Configuration options
 * @returns {Object} The snap manager instance
 */
export const initSnapping = (canvas, options = {}) => {
  if (!canvas) {
    console.warn('initSnapping: No canvas provided');
    return null;
  }

  // Destroy existing manager if present
  if (snapManager) {
    snapManager.destroy();
  }

  // Load snap settings from config
  const snapSettings = getSnapSettings();

  // Create SnapManager with options from editorConfig
  snapManager = createSnapManager(canvas, {
    ...snapSettings,
    ...options, // Allow overriding defaults
  });

  return snapManager;
};

/**
 * Get the current snap manager instance
 * @returns {Object|null} The snap manager or null if not initialized
 */
export const getSnapManager = () => snapManager;

/**
 * Update snapping options
 * @param {Object} options - New options to merge
 */
export const updateSnappingOptions = (options) => {
  if (snapManager) {
    snapManager.updateOptions(options);
  }
};
